import { render, staticRenderFns } from "./BubuiaWrapper.vue?vue&type=template&id=5f18fe7c&scoped=true&"
import script from "./BubuiaWrapper.vue?vue&type=script&lang=js&"
export * from "./BubuiaWrapper.vue?vue&type=script&lang=js&"
import style0 from "./BubuiaWrapper.vue?vue&type=style&index=0&id=5f18fe7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f18fe7c",
  null
  
)

export default component.exports